import React from 'react';

import { useIntl } from 'react-intl';

import ConfirmDialog from 'components/confirm-dialog';
import { useAuthContext } from 'state/auth';

interface IExistingModalDialogProps {
  showDialog: boolean;
  dismiss: () => void;
}

const ExistingEmailDialog: React.FC<React.PropsWithChildren<IExistingModalDialogProps>> = ({
  showDialog,
  dismiss,
}) => {
  const { formatMessage } = useIntl();
  const { openSignInModal } = useAuthContext();

  return (
    <ConfirmDialog
      showDialog={showDialog}
      body={formatMessage({ id: 'logInWithExistingEmail' })}
      confirmLabel={formatMessage({ id: 'logIn' })}
      heading={formatMessage({ id: 'welcomeBack' })}
      onCancel={dismiss}
      onConfirm={() => {
        dismiss();
        openSignInModal();
      }}
      onDismiss={dismiss}
      modalAppearanceEventMessage="Email exists sign in prompt modal"
    />
  );
};

export default ExistingEmailDialog;
